const numberConverter = (num, digits = 0) =>
  num &&
  Number.parseFloat(num)
    .toFixed(digits)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

export default numberConverter
